/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { extend } from '../extend/index.js';
import callPhone$3 from './cn/index.js';
import callPhone$1 from './web/index.js';
import callPhone$4 from './panguMiniApp/index.js';
import callPhone$2 from './mini/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var extendCallPhone = extend({
    // 兜底容器
    web: callPhone$1,
    mini: callPhone$2,
    // 特定端
    cn: callPhone$3,
    panguMiniApp: callPhone$4,
});
/**
 * 拨打电话。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
 * @param {!string | number | CallPhoneIOptions} phoneNumber 电话号码
 * @returns {Promise<unknown>} promise调用结果
 *
 * @example
 * import { callPhone } from '@alife/cn-uni-api';
 *
 * callPhone('18521566878').then(() => {
 *   console.log('success');
 * }).catch((error) => {
 *   console.log(error);
 * });
 * @author 敬文
 */
var callPhone = function (phoneNumber) {
    if (phoneNumber && typeof phoneNumber === 'object') {
        return extendCallPhone(phoneNumber);
    }
    return extendCallPhone({ phoneNumber: "".concat(phoneNumber) });
};

export { callPhone };
